import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=82e65a62&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./css/footer.css?vue&type=style&index=0&id=82e65a62&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e65a62",
  null
  
)

export default component.exports